module.exports = __webpack_public_path__ + "nunito-sans-latin-900.e22a661eeed6baa960d645c48de5a00f.woff2";